import { Layout } from "antd";
import { Outlet } from "react-router";

import AboutModal from "@/modules/about-modal";
import { AppBroadcastingHandler } from "@/modules/app-broadcasting";
import { AppNotificationHandler } from "@/modules/app-notification";
import { EventActionsHandler } from "@/modules/event-actions-handler";
import { useOrganizationContextInvalid } from "@/modules/organization/organization-context";
import { PageError } from "@/modules/page-error";
import PreviewModal from "@/modules/preview-modal";
import SidePanel from "@/modules/side-panel";
import { useAuthContext } from "@/services/auth";
import { LanguageHandler } from "@/services/language";

import { AppLayoutHeader } from "./app-layout-header";
import { AppLayoutSidebar } from "./app-layout-sidebar";
import { AppLayoutTokenRefresher } from "./app-layout-token-refresher";

import "./app-layout.style.less";

export const AppLayout = () => {
  const { hasToken } = useAuthContext();
  const { isInvalid, redirectContext } = useOrganizationContextInvalid();

  return (
    <Layout className="stelar-layout">
      <AppLayoutHeader />
      <Layout className="stelar-layout-body">
        {hasToken && <SidePanel />}
        {hasToken && <PreviewModal />}
        {hasToken && !isInvalid && <AppLayoutSidebar />}
        <AboutModal />
        <Layout className="stelar-layout-content">
          {isInvalid ? (
            <PageError isContextIssue customContext={redirectContext} />
          ) : (
            <Outlet />
          )}
        </Layout>
      </Layout>
      <AppBroadcastingHandler />
      <EventActionsHandler />
      <LanguageHandler />
      <AppLayoutTokenRefresher />
      <AppNotificationHandler />
    </Layout>
  );
};
